import { values } from '@fortem-monorepo/js-utilities';
export const BARRIER_TYPE = {
    DownAndIn: 'Down-and-In',
    DownAndOut: 'Down-and-Out',
    UpAndIn: 'Up-and-In',
    UpAndOut: 'Up-and-Out',
};
export const BARRIER_TYPES = values(BARRIER_TYPE);
